module.exports = "<div class=\"modal-header\">\n    <h3 class=\"modal-title\">Forgotten your username?</h3>\n</div>\n\n<div class=\"modal-body text-cente\">\n    <p>Your username is the same one you use to login to the website.</p>\n\n    <p>You can recover your username by contacting All About Caring during business hours.</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/endpoints/auth/login/forgotUsernameModal.html
// module id = 1017
// module chunks = 0